<template>
    <div uk-grid>
        <div v-if="personData.firstname" class="uk-width-1-3@m">
            <h3>{{ $t("Empfänger") }}</h3>

            {{personData.firstname.value}} {{personData.lastname.value}}<br>
            {{personData.address.value}}<br>
            {{personData.zip.value}} {{personData.city.value}}<br>
            {{getCountryName(personData.country.value)}}
        </div>

        <div class="uk-width-2-3@m" v-if="otherFields.length">
            <h3>{{ $t('Weitere Angaben') }}</h3>
            <div uk-grid class="uk-form-stacked uk-grid-small">
                <div v-for="field in otherFields">
                    <label class="uk-form-label">{{ $t(field.label) }}</label>
                    <div class="uk-form-controls">
                        {{ field.type === "country" ? getCountryName(field.value) : field.value }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "../../helper/helper";
import personFields from "../../forms/personFields.json";
import CountryCodes from "../countryCodes";

export default {
    mixins: [helper],
    props: [],
    components: {},
    data: () => {
        return {
            personData: {},
            otherFields: []
        }
    },
    mounted() {
        Object.keys(personFields).forEach(fieldName => {
            const field = personFields[fieldName];
            if (field.type !== "spacer") {
                this.personData[fieldName] = field;
                this.personData[fieldName].value = this.store.state.personData[fieldName];
            }
        })
        const addressFields = ['firstname', 'lastname', 'city', 'zip', 'address', 'country'];
        this.otherFields = Object.keys(this.personData)
            .filter(fieldName => !addressFields.includes(fieldName))
            .map(fieldName => this.personData[fieldName])
            // Firma und USt-Id werden nur erhoben, wenn der Shop sie anbietet — und an der
            // Reseller-Kasse auch dann, wenn die Option aus ist. Deshalb entscheidet der
            // ausgefüllte Wert, ob die Zeile erscheint, nicht die Einstellung: sonst fehlt,
            // was der Kassierer gerade eingetippt hat, oder es stehen leere Zeilen da.
            .filter(field => String(field.value ?? '').trim() !== '');
    },
    methods: {
        getCountryName(code) {
            const country = CountryCodes[this.$root.$i18n.locale].filter(country => country.code === code);
            return country.length ? country[0].name : ''
        }
    }
}
</script>
